import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button, Flex, Text } from 'onefaceui-react-components';
import Modal from 'react/components/Modal';
import { getResourceTo } from 'react/utils/utils';
import { useDispatch } from 'react-redux';
import routeSummary from 'react/api/actions/routeSummary';

function Footer({ onClose, onManageAssignments }) {
  return (
    <Flex
      justifyContent="flex-end"
      flexDirection="row"
      gap={15}
      style={{ padding: '10px 15px' }}
    >
      <Button
        variant="secondary"
        onClick={onClose}
        dataTestId="missing-driver-cancel-btn"
      >
        {getResourceTo('default.button.cancel')}
      </Button>
      <Button
        variant="primary"
        onClick={onManageAssignments}
        dataTestId="missing-driver-manage-btn"
      >
        {getResourceTo('routeMissingDriver.button.manageAssignments')}
      </Button>
    </Flex>
  );
}

Footer.propTypes = {
  onClose: PropTypes.func.isRequired,
  onManageAssignments: PropTypes.func.isRequired
};

function RouteSummaryMissingDriverModal({ isOpen }) {
  const dispatch = useDispatch();
  const closeMissingDriverModal = useCallback(() => {
    dispatch(routeSummary.actionCreators.resetStopCandidate());
    dispatch(routeSummary.actionCreators.missingDriverModal.closeModal());
  }, []);

  const goToManagementAssignments = useCallback(() => {
    dispatch(routeSummary.actionCreators.missingDriverModal.closeModal());
    dispatch(routeSummary.actionCreators.assignDriverModal.openModal());
  }, [dispatch]);

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      className="missing-driver-modal route-summary-modal"
      isOpen={isOpen}
      title={getResourceTo('routeMissingDriver.modal.title')}
      crossAxisBtn={false}
      footer={
        <Footer
          onClose={closeMissingDriverModal}
          onManageAssignments={goToManagementAssignments}
        />
      }
      closeModalFn={closeMissingDriverModal}
    >
      <Flex justifyContent="center" flexDirection="column">
        <Text size="xs">
          {getResourceTo('routeMissingDriver.modal.message')}
        </Text>
      </Flex>
    </Modal>
  );
}

RouteSummaryMissingDriverModal.propTypes = {
  isOpen: PropTypes.bool
};

RouteSummaryMissingDriverModal.defaultProps = {
  isOpen: false
};

export default RouteSummaryMissingDriverModal;
